const getLocale = state => state.preferences.locale;

export { getLocale };



// WEBPACK FOOTER //
// ./src/selectors/preferences.js